import { NextRouter } from 'next/router';
import { create } from 'zustand';

import { updateFilters } from 'layout/Listing/hooks/useUpdateFilters';

interface BlogListingStore {
  filters: string;
  search: string;
  resultCount: number;
  maxResults: number;
}

export const blogFilterDefaultState = {
  filters: 'All',
  search: '',
  resultCount: 0,
  maxResults: 0,
};

const useBlogListingStore = create<BlogListingStore>(() => blogFilterDefaultState);

const updateSearch = (search: string) => ({ search });

export const updateBlogFilters = (router: NextRouter, value: string) => {
  useBlogListingStore.setState(() => ({ filters: value }));
  updateFilters(router, { category: value });
};
export const setBlogSearch = (search: string) => useBlogListingStore.setState(() => updateSearch(search));

export const setResultCount = (resultCount: number) => useBlogListingStore.setState(() => ({ resultCount }));

export const setMaxResults = (maxResults: number) => useBlogListingStore.setState(() => ({ maxResults }));

export const clearBlogFilters = () => useBlogListingStore.setState(() => blogFilterDefaultState);

export default useBlogListingStore;
